"use client";

import React from "react";
import useGetCollegePlayer from "rivals/services/getCollegePlayer/useGetCollegePlayer";
import useGetProspect from "rivals/services/getProspect/useGetProspect";
import { AthleteViews, PersonIdParams } from "rivals/shared/interfaces/Athlete";
import { Props as CardProps, WrapperProps } from "./types";
import AthleteCard from ".";

export default function AthleteCardContainer(
  props: WrapperProps
): React.JSX.Element {
  const personId = (props.args as PersonIdParams).personId;

  const shouldFetchCollegePlayer =
    props.view === AthleteViews.COLLEGE_PLAYER_VIEW && !!personId;

  const shouldFetchProspect = props.view === AthleteViews.PROSPECT_VIEW;

  const { data: getCollegePlayerResponse } = useGetCollegePlayer(
    { personId },
    { shouldFetch: shouldFetchCollegePlayer }
  );

  const { data: getProspectResponse } = useGetProspect(props.args, {
    shouldFetch: shouldFetchProspect
  });

  const cardProps: CardProps = {
    ...props,
    collegePlayer: getCollegePlayerResponse?.collegePlayer,
    prospect: getProspectResponse?.prospect
  };

  return <AthleteCard {...cardProps} />;
}
